'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * TRAVIS is at "Contacted" on the testimonial tracker with no reply on
 * record, so this sits under `_held/` until approval, like the stories in
 * #200. Move the directory up one level in the commit that lands approval.
 *
 * Sourced from the Open <> TRAVIS daily standups (Apr–Jun 2026, in the
 * communications archive), the "Travis — Pilot & Success" Linear project and
 * the HubSpot company record.
 *
 * No stats row and no results table, deliberately: the only automation
 * number anyone has said out loud is an Open-side aspiration on a call
 * ("we can aim for even more than 50%"). That is a target, not a measured
 * result, and it must not be promoted into a claim here. Add the stats, the
 * table and the six-place number check from the customer-stories skill in
 * the same commit that lands figures TRAVIS has agreed to.
 *
 * FOLLOW-UP: no /logos/logo-travis.svg exists yet, so the aside runs
 * without a logo. */
const TravisCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="TRAVIS"
        title={t.customerStories['travis_hero_title']}
        subtitle={t.customerStories['travis_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'TRAVIS',
          customerName: 'TRAVIS',
          company: t.customerStories['travis_company_description'],
          industry: t.customerStories['travis_industry'],
          websiteUrl: 'https://www.yourtravis.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['travis_location'],
            },
          ],
          keyResults: [
            t.customerStories['travis_key_result_1'],
            t.customerStories['travis_key_result_2'],
            t.customerStories['travis_key_result_3'],
            t.customerStories['travis_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['travis_intro']}</p>

        <h2>{t.customerStories['travis_challenge_title']}</h2>
        <p>{t.customerStories['travis_challenge_p1']}</p>
        <p>{t.customerStories['travis_challenge_p2']}</p>
        <p>{t.customerStories['travis_challenge_p3']}</p>

        <h2>{t.customerStories['travis_solution_title']}</h2>
        <p>{t.customerStories['travis_solution_p1']}</p>
        <p>{t.customerStories['travis_solution_p2']}</p>
        <p>{t.customerStories['travis_solution_p3']}</p>
        <p>{t.customerStories['travis_solution_p4']}</p>

        <h2>{t.customerStories['travis_impact_title']}</h2>
        <p>{t.customerStories['travis_impact_p1']}</p>
        <p>{t.customerStories['travis_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default TravisCaseStudy;
